import {
  INICIA_DISCIPLINA,
  SALVA_DISCIPLINA,
  REMOVE_DISCIPLINA,
  NOVO_DISCIPLINA,
  BUSCA_DISCIPLINA_EDICAO,
  INICIO_DISCIPLINA_SUCESSO,
  SALVA_DISCIPLINA_SUCESSO,
  REMOVE_DISCIPLINA_SUCESSO,
  BUSCA_DISCIPLINA_EDICAO_SUCESSO,
  ATUALIZA_DISCIPLINA,
  ON_SHOW_LOADER,
  ON_SHOW_SUCCESS_MESSAGE,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  LISTA_DISCIPLINA,
  LISTA_DISCIPLINA_SUCESSO,
  LIMPAR_DISCIPLINA,
  APLICA_FILTRO_DISCIPLINA
} from 'constants/ActionTypes';

export const onChangeFilterDisciplina = (e) => ({
  type: APLICA_FILTRO_DISCIPLINA,
  payload: e.target.value
});

export const iniciaDisciplina = () => ({ type: INICIA_DISCIPLINA });

export const salvaDisciplina = (disciplina) => ({ type: SALVA_DISCIPLINA, payload: disciplina });

export const atualizaDisciplina = (disciplina) => ({ type: ATUALIZA_DISCIPLINA, payload: disciplina });

export const removeDisciplina = (id) => ({ type: REMOVE_DISCIPLINA, payload: id });

export const listaDisciplina = (nome) => ({ type: LISTA_DISCIPLINA, payload: { nome: nome == undefined ? '' : nome } });

export const novoDisciplina = () => ({ type: NOVO_DISCIPLINA });

export const buscaDisciplinaEdicao = (id) => ({ type: BUSCA_DISCIPLINA_EDICAO, payload: id });

export const inicioDisciplinaSucesso = (disciplina) => ({ type: INICIO_DISCIPLINA_SUCESSO, payload: disciplina });

export const salvaDisciplinaSucesso = (mensagem) => ({ type: SALVA_DISCIPLINA_SUCESSO, payload: mensagem });

export const removeDisciplinaSucesso = (mensagem) => ({ type: REMOVE_DISCIPLINA_SUCESSO, payload: mensagem });

export const buscaDisciplinaEdicaoSucesso = (disciplina) => ({ type: BUSCA_DISCIPLINA_EDICAO_SUCESSO, payload: disciplina });

export const listaDisciplinaSucesso = (disciplina) => ({ type: LISTA_DISCIPLINA_SUCESSO, payload: { disciplina } });

export const limparFiltroDisciplina = () => ({ type: LIMPAR_DISCIPLINA });

export const exibirMensagemErro = (message) => ({ type: SHOW_MESSAGE, payload: message });

export const showAuthLoader = () => ({ type: ON_SHOW_LOADER });

export const hideMessage = () => ({ type: HIDE_MESSAGE });

export const showAuthMessage = (message) => ({ type: SHOW_MESSAGE, payload: message });

export const showSuccessMessage = (message) => ({ type: ON_SHOW_SUCCESS_MESSAGE, payload: message });

